// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Ip3l","newExpiryDate":"styles_newExpiryDate__3skhM","footer":"styles_footer__vC8KF"};